import http from 'services/http';
import URIS from '../constants/uris';

export function getRules() {
  return http.get(URIS.GDPR_RULES).then(({ data }) => data);
}
